import { createContext } from "react";

interface TeamsContextProps {
  themeString: string;
  userName: string;
  token: string;
}

export const TeamsFxContext = createContext<TeamsContextProps>({
  themeString: "",
  userName: "",
  token: "",
});
